import React from "react";
import { useSelector } from 'react-redux';
import { Card, Divider, Typography } from "antd";
import { Col, Row } from 'antd';


export const cardStyles = {
    headStyle: {
        backgroundColor: '#FFF',
        color: 'black',
        border: '2px solid transparent',
        background: `
                    linear-gradient(white, white) padding-box,
                    linear-gradient(to bottom, #977e5b, #c3b08f) border-box
                `,
        borderButton: "none",
    },
    bodyColor: {
        body: {
            border: '2px solid transparent',
            background: `linear-gradient(white, white) padding-box,
             linear-gradient(to bottom, #977e5b, #c3b08f) border-box`,
            borderRadius: '8px',
        },
    },
    bodyStyle: {
        body: {
            borderRight: '2px solid #d6d1ca',
            borderLeft: ' 2px solid #d6d1ca',
            borderBottom: '2px solid #d6d1ca',
            borderTop: "none"
        }
    }
};


export default function UserInformation() {
    const userDataSlice = useSelector(store => store.userDataSlice); 
    return (
        <div>
            <Row>
                <Col span={24}>
                    <Divider>
                        <Typography.Title level={4}>Colegio de Educación Profesional Técnica del Estado de México</Typography.Title>
                    </Divider>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Card
                        size="small"
                        styles={{ ...cardStyles.bodyColor }}
                    >
                        <strong>Bienvenid@, {userDataSlice?.user} </strong><br />
                        <strong>Correo Institucional: </strong> {userDataSlice?.correo_institucional} <br />
                        <strong>Rol: </strong> {Array.isArray(userDataSlice?.rol) && userDataSlice.rol.length > 0 && userDataSlice.rol.join(", ")} <br />
                        <strong>Unidad Administrativa / Plantel: </strong>
                        {userDataSlice?.adscripcion?.plantel?.length
                            ? userDataSlice.adscripcion?.plantel?.map(item => item.nombre_plantel).join(", ")
                            : "No hay planteles"}
                        <br />
                        <strong>Área: </strong>
                        {userDataSlice?.adscripcion?.cmi_areas?.length
                            ? userDataSlice.adscripcion?.cmi_areas?.map(item => item.nombre).join(", ")
                            : "No hay áreas"}
                        <br /> 
                    </Card>
                </Col>
            </Row>
        </div>
    )
}